<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="devpointinfo" :rules="rules" ref="devpointrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="点位名称" prop="name">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.name" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="控制器id" prop="controlid">
						<el-input clearable disabled v-model="devpointinfo.controlid" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="设备id" prop="devid">
						<el-input clearable disabled v-model="devpointinfo.devid" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="点位id" prop="propertyid">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.propertyid" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="点位类型" prop="monitortype">
						<el-select style="width: 100%;" :disabled="!editok" v-model="devpointinfo.monitortype" placeholder="请选择点位类型">
							<el-option v-for="item in monitorlist" :key="item.name" :label="item.name" :value="item.name"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="单位" prop="unit">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.unit" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="图标url" prop="icon">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.icon" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="排序" prop="idx">
						<el-input-number :disabled="!editok" v-model="devpointinfo.idx" :min="1" :max="999" :precision="2" :step="0.1" ></el-input-number>
						<!-- <el-input type="textarea" :rows="4" placeholder="请输入配置参数" maxlength="99999" clearable v-model="devpointinfo.value"></el-input> -->
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="首页显示" prop="defaultshow">
						<el-select style="width: 100%;" :disabled="!editok" v-model="devpointinfo.defaultshow" placeholder="请选择是否首页显示">
							<el-option v-for="item in showlist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="枚举" prop="enums">
						<el-input type="textarea" :rows="4" clearable :disabled="!editok" v-model="devpointinfo.enums" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="定时任务1" prop="task1">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.task1" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="定时任务2" prop="task2">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.task2" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="定时任务3" prop="task3">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.task3" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="定时任务4" prop="task4">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.task4" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="定时任务5" prop="task5">
						<el-input clearable :disabled="!editok" v-model="devpointinfo.task5" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="savedevpointinfo">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { addDevPoint,editDevPoint } from '/static/apiUrl.js'
	export default {
		name : 'DevPointDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				/* uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},	 */
				showlist : [
					{
						code : 'Y',
						name : '显示'
					},
					{
						code : 'N',
						name : '不显示'
					}
				],
				monitorlist : [
					{
						name : '遥测信号'
					},
					{
						name : '遥控信号'
					}
				],
				devpointinfo : {
					id: "",
					name: "",
					devid: "",
					controlid: "",
					propertyid : '',
					monitortype : '',
					icon : '',
					idx : 0,
					defaultshow : '',
					unit : '',
					enums : '',
					task1 : '',
					task2 : '',
					task3 : '',
					task4 : '',
					task5 : '',
				},
				rules:{
					name: [
						{ required: true, message: '请输入点位名称', trigger: 'blur' }
					],
					propertyid: [
						{ required: true, message: '请选择校区', trigger: 'blur' }
					],
					controlid: [
						{ required: true, message: '请输入控制器id', trigger: 'blur' }
					],
					devid: [
						{ required: true, message: '请输入设备id', trigger: 'blur' }
					],
					monitortype : [
						{required: true, message: '请选择点位类型', trigger: 'blur'},
					],
					
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedset: {
				type: Object,
				required: false
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			}
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectedset: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.devpointinfo.id= newVal.id
						this.devpointinfo.name= newVal.name
						this.devpointinfo.devid= newVal.devid
						this.devpointinfo.controlid= newVal.controlid
						this.devpointinfo.propertyid = newVal.propertyid
						this.devpointinfo.monitortype = newVal.monitortype
						this.devpointinfo.icon = newVal.icon
						this.devpointinfo.idx = newVal.idx
						this.devpointinfo.defaultshow = newVal.defaultshow
						this.devpointinfo.unit = newVal.unit
						this.devpointinfo.enums = newVal.enums
						this.devpointinfo.task1 = newVal.task1
						this.devpointinfo.task2 = newVal.task2
						this.devpointinfo.task3 = newVal.task3
						this.devpointinfo.task4 = newVal.task4
						this.devpointinfo.task5 = newVal.task5
					}else{
						this.devpointinfo.id= ""
						this.devpointinfo.name= ""
						this.devpointinfo.devid= ""
						this.devpointinfo.controlid= ""
						this.devpointinfo.propertyid = ''
						this.devpointinfo.monitortype = ''
						this.devpointinfo.icon = ''
						this.devpointinfo.idx = 0
						this.devpointinfo.defaultshow = ''
						this.devpointinfo.unit = ''
						this.devpointinfo.enums = ''
						this.devpointinfo.task1 = ''
						this.devpointinfo.task2 = ''
						this.devpointinfo.task3 = ''
						this.devpointinfo.task4 = ''
						this.devpointinfo.task5 = ''
					}
				}
			},
		},
		methods: {
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needPointRefrash",false,false)
				}
			},
			savedevpointinfo(){
				//this.editok = false
				this.$refs["devpointrule"].validate((valid) => {
					if (valid) {
						let checkok = true
						if(!checkok){
							this.$message({
								showClose: true,
								message: "请完善数据信息",
								type: 'warning'
							});
						}else{
							if(this.devpointinfo.id != null && this.devpointinfo.id != ''){  //编辑
								editDevPoint(this.devpointinfo).then(res => {
									if(0 == res.code){
										this.$message({
											showClose: true,
											message: "添加成功",
											type: 'success'
										});
										this.$emit("needPointRefrash",true,false)
									}else{
										this.$message({
											showClose: true,
											message: res.message,
											type: 'error'
										});
									}
								})
							}else{ //新增
								addDevPoint(this.devpointinfo).then(res => {
									if(0 == res.code){
										this.$message({
											showClose: true,
											message: "修改成功",
											type: 'success'
										});
										this.$emit("needPointRefrash",true,false)
									}else{
										this.$message({
											showClose: true,
											message: res.message,
											type: 'error'
										});
									}
								})
							}
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>